import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span>{{this.label}}</span>", {
  moduleName: "select-kit/components/create-color-row.hbs"
});